import { Agent } from "app/shared/model";
import { AgentSearchState } from "app/pages/DiscountEditor/modules/Agent/state";


export interface AgentItemsListState {
    agents: AgentListItem[],
    searchTerm: string, 
    searchStatus: AgentSearchStatus,
}

export interface AgentListItem {
    id: string, 
    name: string, 
    ownerFullName: string
    countryName: string
    countryIsoCode: string|undefined
    classification: string, 
    status: AgentListItemStatus 
}

export interface AgentListItemStatus {
    name: string, 
    cssClass: string
}

export enum AgentSearchStatus {
     Running = 'Running', 
     Errored = 'Errored', 
     Success = 'Success',
 }